import React from 'react';
import { Link } from 'react-router-dom';

const STEPS = [
  {
    title: "MONITOR",
    desc: "See competitor campaigns, messages, offers and creative activity."
  },
  {
    title: "INTERPRET",
    desc: "Understand the patterns, implications, gaps and opportunities."
  },
  {
    title: "ACT",
    desc: "Turn intelligence into strategy, campaigns and creative execution."
  }
];

export default function WhatWeDo() {
  return (
    <section id="the-guide" className="py-[80px] bg-[#030509] border-t border-[#242832]">
      <div className="w-[calc(100%-40px)] md:w-[calc(100%-64px)] max-w-[1200px] mx-auto">
        <div className="max-w-[800px] mb-[48px]">
          <h2 className="text-[clamp(34px,3.8vw,54px)] font-semibold text-white leading-[1.08] tracking-[-0.035em] mb-[24px]">
            Maxmark turns market activity into direction.
          </h2>
          <p className="text-[clamp(17px,1.3vw,20px)] text-[#A7ADB8] leading-[1.65] font-normal">
            We combine competitor monitoring, advertising intelligence and strategic interpretation to help your team understand what matters and decide what to do next.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[32px] md:gap-[48px] mb-[48px]">
          {STEPS.map((step, index) => (
            <div key={index} className="pt-[24px] border-t border-[#242832]">
              <h3 className="text-[18px] font-semibold text-white tracking-wide mb-[16px]">{step.title}</h3>
              <p className="text-[16px] text-[#A7ADB8] leading-[1.65] font-normal">{step.desc}</p>
            </div>
          ))}
        </div>

        <div>
          <Link to="/intelligence" className="inline-block text-[13px] font-bold uppercase tracking-[0.1em] text-[#2F6BFF] hover:text-white transition-colors">
            Explore Our Intelligence Approach →
          </Link>
        </div>
      </div>
    </section>
  );
}